'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '../Icon/Icon.js';
export const ChipsItem = (_a) => {
    var { className, dismissible, onClick, text, size, variant } = _a, other = __rest(_a, ["className", "dismissible", "onClick", "text", "size", "variant"]);
    const [isDismissed, setIsDismissed] = React.useState(false);
    function handleOnClick(e) {
        e.preventDefault();
        if (dismissible) {
            setIsDismissed(true);
        }
        if (onClick) {
            onClick(e);
        }
    }
    const componentClassName = classnames('sparky-c-chips__item', className, {
        'sparky-c-chips__item--sm': size == 'sm',
        'sparky-c-chips__item--lg': size == 'lg',
        'sparky-c-chips__item--primary': variant == 'primary',
    });
    return isDismissed !== true ? (_jsx("li", Object.assign({ className: componentClassName }, other, { children: _jsxs("button", Object.assign({ className: "sparky-c-chips__button", onClick: (e) => handleOnClick(e), type: "button" }, { children: [_jsx("span", Object.assign({ className: "sparky-c-chips__text" }, { children: text })), dismissible && (_jsx(Icon, { className: "sparky-c-chips__icon", name: "x-circle", title: "Close", size: "md" }))] })) }))) : null;
};
//# sourceMappingURL=ChipsItem.js.map